import React from 'react';
import Image from '../../../../generic/Image';
import TransitionOpacityReveal from '../../../../generic/TransitionOpacityReveal';
import { Fixed } from '../../../ScrollProgression';
import InfoCard from '../InfoCard';
import styles from './index.module.scss';

export default function MaskContainer({ spot, isActive, closeFn, alternatePos = false }) {
  return (
    <>
      <Fixed
        overlay={<InfoCard spot={spot} isVisible={isActive} closeFn={closeFn} alternatePos={alternatePos} />}
        breakOverlay
        constrainOverlay
        className={styles.maskContainer}
      >
        <FadeOutOnInvisible isVisible={isActive}>
          {Boolean(spot?.image?.fluid) && <Image fluid={spot?.image?.fluid} alt={spot?.image?.description} />}
        </FadeOutOnInvisible>
      </Fixed>
    </>
  );
}

function FadeOutOnInvisible({ isVisible, children }) {
  return <TransitionOpacityReveal isVisible={isVisible}>{children}</TransitionOpacityReveal>;
}
